import axios, { AxiosInstance } from 'axios';

export const getAxiosWithConfig = (): AxiosInstance => {
  const apiKey = document.querySelector('[data-api-key]')?.getAttribute('data-api-key');
  const apiUrl = document.querySelector('[data-api-key]')?.getAttribute('data-api-url');
  return axios.create({
    baseURL: '' + apiUrl,
    timeout: 30000,
    headers: {
      Authorization: 'Bearer ' + apiKey,
    },
  });
};

export const getAxiosWithConfigAdmin = (token: string): AxiosInstance => {
  const apiUrl = document.querySelector('[data-api-key]')?.getAttribute('data-api-url');
  return axios.create({
    baseURL: '' + apiUrl,
    timeout: 30000,
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};
